<template>
    <div>
        <redeem-button
            :isLogin="isLogin"
            :point="availablePoint"
            :selectedPoint="selectedPoint"
            :selectedQuantity="selectedQuantity"
            :lblRedeemBTN="lbl.redeem_button"
            :campaign="campaign"
            :redeemBTN="redeemBTN"
            v-if="isForceRender"
            @clickRedeem="clickRedeem()">
        </redeem-button>

        <modal view="redeem-component"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>
        <confirm-redeem-modal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmRedeem"
            @clickConfirmRedeem="clickConfirmRedeem()"></confirm-redeem-modal>
        <confirm-select-store-modal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmStore"
            @clickConfirmSelectStore="clickConfirmSelectStore($event)"></confirm-select-store-modal>
        <confirm-select-booking-modal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmBooking"
            :errorMessage="errorMessage"
            @clickConfirmSelectStore="clickConfirmSelectStore($event)"
            @clickCancelSelectStore="clickCancelSelectStore($event)"
            ></confirm-select-booking-modal>
        <serial-modal
            :lbl="lbl"
            :busSerialModal="busSerialModal"></serial-modal>
        <shipping-address-modal
            :lblShipping="lbl.shipping"
            :shippingAddress="shippingAddress"
            :errorInfo="shippingAddressValidateInfo"
            :busShippingModal="busShippingModal"
            @clickConfirmAddress="clickConfirmAddress($event)"></shipping-address-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Account from '@/helper/AccountHelper.js';
import RedeemButton from '@/components/campaign/detail/RedeemButton.vue';
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper";
//Service
import BzbsCampaign from '@/service/BzbsCampaign.js';
import DiorApi from "@/service/dior/DiorApi.js";
import {
    CampaignConfigBuilder,
    RedeemConfigBuilder,
    RedeemShippingAdressBuilder,
    RedeemInfoConfigBuilder
} from '@/service/config/CampaignConfigModel.js';
//Modal
import Modal from '@/components/modal/Modal.vue';
import ConfirmRedeemModal from '@/components/modal/ConfirmRedeemModal.vue';
import ConfirmSelectStoreModal from '@/components/modal/ConfirmSelectStoreModal.vue';
import ConfirmSelectBookingModal from '@/components/modal/ConfirmSelectBooking.vue';
import SerialModal from '@/components/modal/SerialModal.vue';
import ShippingAddressModal from '@/components/modal/ShippingAddressModal.vue';
/**
 * Property
 * @property {object} lbl Text for Component.
 * @property {object} campaign Campaign model.
 * @property {number} selectedId Selected campaign for redeem in case of campaign contain sub-campaign.
 * @property {number} selectedQuantity Selected campaign quantity.
 * @property {number} selectedPoint Selected campaign use/get point.
 * Event
 * @event clickRedeem Click validate redeem.
 * @event clickConfirmRedeem Click confirm to proceed redeem define type of campaign.
 * Method
 * @method checkRedeemCondition Check if user can or cannot redeem.
 * @method openWebsite Redirect by campaign condition to website after redeem.
 * @method openSurvey Redirect by campaign condition to website after redeem.
 * @method callInterfaceApi Call api by campaign condition after redeem.
 * @method initialShippingAddress Setup data model and open shipping address modal.
 * @method clickConfirmAddress Validate shipping address and proceed redeem.
 * @method redeem Call redeem api for redeem.
 * @method updateCampaign Call Campaign detail api to update data.
 * @method updateCampaignInfo Emit parent method to update data.
 * @method initialSerialModal Open Serial modal.
 * Utilities
 * @method forceRender Force component to rerender.
 */
export default {
    name: "Redeem",
    components: {
        RedeemButton,
        Modal,
        ConfirmRedeemModal,
        ConfirmSelectStoreModal,
        ConfirmSelectBookingModal,
        SerialModal,
        ShippingAddressModal
    },
    props: {
        lbl: Object,
        campaign: Object,
        selectedId: Number,
        selectedQuantity: Number,
        selectedPoint: Number
    },
    data: function() {
        return {
            isLogin: false,
            availablePoint: 0,
            profileDior: {},
            redeemBTN: {
                strRedeemLabel: '',
                isAllowRedeem: true,
                isButtonDisable: false,
                strDisableClass: 'redeem-disable',
                isUseDefault: false
            },
            redeemConfig: null,
            redeemShippingAdress: null,
            redeemInfoConfig: null,
            redeemLocation: null,
            redeemOtherConfig: null,
            campaignConfig: null,

            serialCampaign: {},
            isForceRender: true,

            shippingAddress: null,
            errorMessage: null,
            shippingAddressValidateInfo: {
               isValid: true,
               msg: ''
            },

            objRedeemInfoConfig: {
                info3: ''
            },

            busModal: new Vue(),
            busConfirmRedeem: new Vue(),
            busSerialModal: new Vue(),
            busShippingModal: new Vue(),
            busConfirmStore: new Vue(),
            busConfirmBooking: new Vue(),

            tracking: new TrackingService(this),
            userId: Account.getLineUserId()
        };
    },
    created: function() {
        // console.log("Redeem");
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.profileDior = Account.getCacheDiorProfile();
            if (this.profileDior && this.profileDior.bonusPointBalance) {
                this.availablePoint = parseInt(this.profileDior.bonusPointBalance);
            }
            this.forceRender();
        });
        this.redeemConfig = new RedeemConfigBuilder().create();
    },
    mounted: function() {
        //this.busConfirmBooking.$emit('showConfirmSelectBookingModal', {});
    },
    methods: {
        //Event
        clickRedeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;
            if(!this.isLogin) return;
            this.busConfirmRedeem.$emit('showConfirmRedeemModal', {});

            let trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
            this.tracking.event('service_list', 'click_EventBooking', trackCamp);
            //this.busConfirmRedeem.$emit('showConfirmSelectStoreModal', {});
        },
        clickConfirmRedeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;

            console.log(this.campaign);
            if (this.campaign.categoryID == 9444344 ||
                this.campaign.categoryID == 9452030 ||
                this.campaign.categoryID == 31828) {


                this.busConfirmBooking.$emit('showConfirmSelectBookingModal', {});
            } else {

                this.busConfirmStore.$emit('showConfirmSelectStoreModal', {});
            }

        },
        clickConfirmSelectStore: function (dataInfo) {
                //redeemConfig
            this.objRedeemInfoConfig.dataInfo = dataInfo.dataInfo;

            if (dataInfo.info5) {
                this.objRedeemInfoConfig.info5 = dataInfo.info5;

                this.objRedeemInfoConfig.info5.name = this.profileDior.firstName;
                this.objRedeemInfoConfig.info5.contact_number = this.profileDior.mobileNumber;
                this.objRedeemInfoConfig.info5.productcode = this.campaign.referenceCode;
            }


            this.redeemConfigInfo = new RedeemInfoConfigBuilder()
                                                .setInfo3(this.objRedeemInfoConfig.info3)
                                                .setInfo5(JSON.stringify(this.objRedeemInfoConfig.info5))
                                                .create();
            console.log(this.redeemConfigInfo);
            var strRedeemCondition = this.checkRedeemCondition();

            if (dataInfo.tag) {
                this.selectedId = dataInfo.id;
            }
            switch(strRedeemCondition) {
                case 'open_web':
                    this.openWebsite();
                    break;
                case 'open_web_survey':
                    this.openSurvey();
                    break;
                case 'call_api':
                    this.callInterfaceApi();
                    //No longer see this being use.
                    break;
                case "update_shipping_address":
                    this.initialShippingAddress();
                    break;
                default:
                    if (this.campaign.categoryID == 9444344 ||
                        this.campaign.categoryID == 9452030 ||
                        this.campaign.categoryID == 31828) {

                        this.redeemBooking();
                    } else {
                        this.redeem();
                    }
                    break;
            }

        },
        clickCancelSelectStore: function () {
            this.errorMessage = "";
        },
        //Function
        checkRedeemCondition: function () {
            var strResult = 'redeem';
            switch(this.campaign.type) {
                case Vue.CampaignType.Buy:
                    strResult = 'open_web';
                    break;
                case Vue.CampaignType.Interface:
                    if(!this.campaign.interfaceDisplay) return;

                    if(this.campaign.interfaceDisplay === 'web') strResult = 'open_web';
                    if(this.campaign.interfaceDisplay === 'survey' || this.campaign.interfaceDisplay === 'surveyapprove') strResult = 'open_web_survey'
                    if(this.campaign.interfaceDisplay === 'api') strResult = 'call_api';
                    break;
                default:
                    if(this.campaign.delivered) strResult = 'update_shipping_address';
                    break;
            }

            return strResult;
        },
        openWebsite: function () {
            if(!this.campaign.website) return;

            var bzbsToken = Account.getToken();
            var localeCode = Locale.getLocaleCode();
            var returnUrl = encodeURIComponent(window.location.href);
            switch(this.campaign.type) {
                case Vue.CampaignType.Buy:
                    var strUrl = '';
                    var strLocale = '';
                    var strEncryptToken = Util.shuffleToken(bzbsToken);
                    switch(localeCode) {
                        case 1033:
                            strLocale = 'E';
                            break;
                        case 1054:
                            strLocale = 'T';
                            break;
                    }

                    if(this.campaign.website.indexOf('.buzzebees.com/payment/')) {
                        var arrSplittedUrl = this.campaign.website.split('/payment');
                        strUrl = Vue.bzbsConfig.bzbShoppingCartUrl + '/payment' + arrSplittedUrl[1] + '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
                    } else {
                        strUrl = this.campaign.website = '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
                    }

                    window.location = strUrl;
                    break;
                case Vue.CampaignType.Interface:
                    var isShowHeader = 'false' //show/hide header.
                    var strTheme = '';
                    var appName = Vue.bzbsConfig.appname
                    window.location.href =
                        this.campaign.website +
                        '&token=' + bzbsToken +
                        '&locale=' + localeCode +
                        '&header=' + isShowHeader +
                        '&theme=' + strTheme +
                        '&appName=' + appName +
                        '&return_url=' + returnUrl; // ReturnUrl;
                    break;
            }
        },
        openSurvey: function () {

        },
        callInterfaceApi: function () {

        },
        //Shipping
        initialShippingAddress: function () {
            this.shippingAddress = Account.getCacheProfileShippingAddres();
            this.busShippingModal.$emit('showShippingAddressModal', {});
        },
        clickConfirmAddress: function () {
            if(!this.shippingAddressValidateInfo.isValid) {
                this.showAlertModal(this.lbl.shipping.alert_headline,
                                    this.shippingAddressValidateInfo.msg,
                                    this.lbl.shipping.alert_ok_btn,
                                    "shipping");
            } else {
                this.redeemShippingAdress = new RedeemShippingAdressBuilder()
                                                .initialWithProfileShippingAddress(this.shippingAddress)
                                                .create();

                this.redeem();
            }
        },
        //Redeem
        redeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;
            console.log("redeem");
            this.showLoading();
            var bzbsToken = Account.getToken();
            BzbsCampaign.apiRedeemCampaign(bzbsToken, this.selectedId, this.redeemConfig, this.redeemShippingAdress, this.redeemConfigInfo, null, null, null)
                .then((campaign) => {

                     this.showThankModal(this.lbl.shipping.thank_header,
                                    this.lbl.shipping.text_thank,
                                    this.lbl.shipping.close);

                    this.campaign.updateAfterRedeem(campaign);
                    this.campaign.updateCampaign(campaign);
                    this.hideLoading();
                    // this.initialSerialModal();

                    // var self = this;
                    // setTimeout(function () {
                    //     self.updateCampaign();
                    // }, 1000);
                }).catch((error) => {
                    this.hideLoading();
                    console.log(error);
                });
        },
        redeemBooking: function () {

            if(!this.redeemBTN.isAllowRedeem) return;
            console.log("redeem");
            this.showLoading();
            var bzbsToken = Account.getToken();
            //var diorProfile = Account.getCacheDiorProfile();
            console.log(this.objRedeemInfoConfig.dataInfo);
            DiorApi.bookingDior(bzbsToken, this.objRedeemInfoConfig.dataInfo)
                .then((campaign) => {
//campaign.data.Status = "101"
                    if (campaign.data.Status == "000" ||
                        campaign.data.Status ==  "001" ||
                        campaign.data.Status ==  "010") {

                        this.campaign.updateAfterRedeem(campaign);
                        this.initialSerialModal(campaign.data.Sequence);

                        var self = this;
                            setTimeout(function () {
                                self.updateCampaign();
                            }, 1000);

                        this.busConfirmBooking.$emit('closeConfirmModal', {});
                    } else {

                        var errorId = campaign.data.Status;

                        var errorMessage = "";
                        switch(errorId) {

                            case "101":
                                errorMessage = this.lbl.redeem_button.error101;
                                break;
                            case "102":
                                errorMessage = this.lbl.redeem_button.error102;
                                break;
                            case "103":
                                errorMessage = this.lbl.redeem_button.error103;
                                break;
                            case "104":
                                errorMessage = this.lbl.redeem_button.error104;
                                break;
                            case "105":
                                errorMessage = this.lbl.redeem_button.error105;
                                break;
                            case "106":
                                errorMessage = this.lbl.redeem_button.error105;
                                break;
                            case "107":
                                errorMessage = this.lbl.redeem_button.error105;
                                break;
                            case "108":
                                errorMessage = this.lbl.redeem_button.error108;
                                break;
                            case "109":
                                errorMessage = this.lbl.redeem_button.error109;
                                break;
                            case "201":
                                errorMessage = this.lbl.redeem_button.error201;
                                break;
                            case "202":
                                errorMessage = this.lbl.redeem_button.error105;
                                break;
                            case "301":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "302":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "303":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "304":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "305":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "306":
                                errorMessage = this.lbl.redeem_button.error301;
                                break;
                            case "999":
                                errorMessage = this.lbl.redeem_button.error999;
                                break;
                            default:
                                errorMessage = this.lbl.redeem_button.error999;
                                // code block
                        }
                        // if (errorId == "101") {

                        //     errorMessage = this.lbl.redeem_button.error101;

                        // }

                        this.errorMessage = errorMessage;
                    }


                    this.hideLoading();

                }).catch((error) => {
                    console.log(error.response);
                    var tmperror = error.response.data.error;

                    var errorMessage = tmperror.message;

                    if (tmperror.id == 1) {

                        errorMessage = this.lbl.redeem_button.soldOutBooking;
                    } else if (tmperror.id == 2) {


                        if (errorMessage == 'already redeem this mastercampaign') {
                            errorMessage = this.lbl.redeem_button.alreadyRedeem;
                        } else {
                            errorMessage = this.lbl.redeem_button.longerEligible;

                        }

                    }

                    this.errorMessage = errorMessage;
                    this.hideLoading();
                    console.log(this.errorMessage);
                });
            // BzbsCampaign.apiRedeemCampaignBooking(bzbsToken, this.selectedId, this.redeemConfig, this.redeemShippingAdress, this.redeemConfigInfo, null, null, diorProfile.memberCode)
            //     .then((campaign) => {

            //         // this.showThankModal(this.lbl.shipping.thank_header,
            //         //                 this.lbl.shipping.text_thank,
            //         //                 this.lbl.shipping.close);
            //         this.campaign.updateAfterRedeem(campaign);
            //         this.initialSerialModal();

            //         var self = this;
            //             setTimeout(function () {
            //                 self.updateCampaign();
            //             }, 1000);

            //         this.busConfirmBooking.$emit('closeConfirmModal', {});
            //         // this.campaign.updateAfterRedeem(campaign);
            //         // this.campaign.updateCampaign(campaign);
            //         this.hideLoading();
            //         // this.initialSerialModal();

            //         // var self = this;
            //         // setTimeout(function () {
            //         //     self.updateCampaign();
            //         // }, 1000);
            //     }).catch((error) => {

            //         console.log(error.response);
            //         var tmperror = error.response.data.error;

            //         var errorMessage = tmperror.message;

            //         if (tmperror.id == 1) {

            //             errorMessage = this.lbl.redeem_button.soldOutBooking;
            //         } else if (tmperror.id == 2) {


            //             if (errorMessage == 'already redeem this mastercampaign') {
            //                 errorMessage = this.lbl.redeem_button.alreadyRedeem;
            //             } else {
            //                 errorMessage = this.lbl.redeem_button.longerEligible;

            //             }

            //         }

            //         this.errorMessage = errorMessage;
            //         this.hideLoading();
            //         console.log(this.errorMessage);
            //     });
        },
        updateCampaign: function () {
            var strBzbsToken = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                    .setCampaignId(this.campaign.id)
                    .create();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((data) => {
                this.campaign.updateCampaign(data);
                this.updateCampaignInfo(data);
                this.forceRender();
            }).catch((error) => {
                console.log(error);
            });
        },
        updateCampaignInfo: function (campaign) {
            this.$emit('updateCampaignInfo', campaign);
        },
        initialSerialModal: function (sequence) {
            this.serialCampaign = this.campaign;
            this.serialCampaign.serial = sequence;
            this.serialCampaign.dataInfo = this.objRedeemInfoConfig.dataInfo;

            this.busSerialModal.$emit('showSerialModal', this.serialCampaign);
        },
        //Utilities
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        // --- modal event ----
        modalConfirmOk: function(event) {
            if (event.tag == 'modal-redeem') {
                this.clickConfirmRedeem();
            }
        },
        showConfirmModal: function(title, message, btnOk, btnCancel, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                strBtnCancel: btnCancel,
                tag: tag,
            };
            this.busModal.$emit('showConfirmModal', configModal);
        },
        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
            switch(e.tag) {
                case 'shipping':
                    this.busShippingModal.$emit('showShippingAddressModal', {});
                    break;
            }
        },
        showThankModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showThankModal', configModal);
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
    } // end methods
};
</script>
